import  { useState } from "react";
import { useTranslation } from "react-i18next";
import HeDatePicker from "../HeDatePicker/HeDatePicker";
import RadioButtons from "../RadioButtons/RadioButtons";
import FilterDepositsPopupProps from "./FilterDepositsPopupProps";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { Chip } from "@mui/material";
import "./FilterDepositsPopup.scss";
import { getFromDateValue } from "../../utils/helpers/dateFormatter";

const FilterDepositsPopup = (props: FilterDepositsPopupProps) => {
  const { t, i18n } = useTranslation("common");
  // The state values is for updating the parent component when change and for popup UI
  const [radioValue, setRadioValue] = useState<string>(props.radioValue);
  const [startDateValue, setStartDateValue] = useState<Date | number | string>(
    props.startDateValue
  );
  const [endDateValue, setEndDateValue] = useState<Date | number | string>(
    props.endDateValue
  );
  const [currentSecondLabel, setSecondLabel] = useState<string>(
    props.currentSecondLabel
  );
  const datePickerIsDisabled = () =>
    radioValue === t("LettersReports.radioValue1");

  const validateDatePickerValues = () => {
    // validate date picker values
    if (
      startDateValue &&
      startDateValue !== "" &&
      endDateValue &&
      endDateValue !== "" &&
      new Date(startDateValue) > new Date(endDateValue)
    ) {
      setStartDateValue(getFromDateValue());
      setEndDateValue(new Date());
    }
  };

  useDidMountEffect(() => {
    props.setRadioValue(radioValue);
  }, [radioValue]);

  useDidMountEffect(() => {
    validateDatePickerValues();
    props.setStartDateValue(startDateValue);
    props.setEndDateValue(endDateValue);
  }, [startDateValue, endDateValue]);

  useDidMountEffect(() => {
    props.setSecondLabel(currentSecondLabel);
  }, [currentSecondLabel]);

  useDidMountEffect(() => {
    setRadioValue(t("LettersReports.radioValue1"));
    setSecondLabel(t("deposits.secondChipLabel1"));
  }, [i18n.language]);

  return (
    <div className="filter-deposits-popup-wrapper">
      <h4 id="dialogTitle">{t("deposits.filterTitle")}</h4>
      <div className="deposits-popup-date-wrapper">
        {/* TODO -AAA move title to rodiobtn */}
        <span className="deposit-popup-label">{t("deposits.dates")}</span>
        <div style={{ marginRight: -10 }}>
          <RadioButtons
            setRadioValue={setRadioValue}
            radioValue={radioValue}
            firstRadioTString="LettersReports.radioValue1"
            secondRadioTString="LettersReports.radioValue2"
            column={true}
          />
        </div>
        <div style={{ padding: "5px 10px" }}>
          <HeDatePicker
            dateLabel={t("general.fromDate")}
            dateValue={startDateValue}
            setDateValue={setStartDateValue}
            isDisabled={datePickerIsDisabled}
            isOpenFun={()=>{}}
          />
        </div>
        <div style={{ padding: "5px 10px 20px" }}>
          <HeDatePicker
            dateLabel={t("general.toDate")}
            dateValue={endDateValue}
            setDateValue={setEndDateValue}
            isDisabled={datePickerIsDisabled}
            isOpenFun={()=>{}}
          />
        </div>
        
        
        <span className="deposit-popup-label">
          {t("deposits.depositsStatus")}
        </span>
        <div className="deposit-popup-chips-wrapper">
          {/* Not in loop because css problems, and its only 3 constants labels values. */}
          <Chip
            label={props.SecondChipLabels[0]}
            sx={{
              color:`${
                currentSecondLabel === props.SecondChipLabels[0]
                ? "white"
                : ""
              }`,
              fontFamily: "Assistant",
              fontSize: "18px",
              height: "35px",
              borderRadius: "32px",
              backgroundColor: `${
                currentSecondLabel === props.SecondChipLabels[0]
                  ? "#0250C1"
                  : ""
              }`,
              "&:hover": {               
                backgroundColor: `${
                  props.SecondChipLabels[0] ? "#0250C1" : ""
                }`,
                color:`${
                  props.SecondChipLabels[0]
                   ? "white"
                   : ""
                 }`,
              },
            }}
            onClick={() => setSecondLabel(props.SecondChipLabels[0])}
          />
          <Chip          
            label={props.SecondChipLabels[1]}
            sx={{
              color:`${
                currentSecondLabel === props.SecondChipLabels[1]
                ? "white"
                : ""
              }`,
              fontFamily: "Assistant",
              fontSize: "18px",
              height: "35px",
              borderRadius: "32px",
              backgroundColor: `${
                currentSecondLabel === props.SecondChipLabels[1]
                  ? "#0250C1"
                  : ""
              }`,
              "&:hover": {
                backgroundColor: `${
                  props.SecondChipLabels[1] ? "#0250C1" : ""
                }`,
                color:`${
                  props.SecondChipLabels[1]
                   ? "white"
                   : ""
                 }`,
              },
            }}
            onClick={() => setSecondLabel(props.SecondChipLabels[1])}
          />
        </div>
        {props.showFilterBtn && 
        <div >
          <Chip
            label={props.SecondChipLabels[2]}
            sx={{
              color:`${
                currentSecondLabel === props.SecondChipLabels[2]
                ? "white"
                : ""
              }`,
              fontFamily: "Assistant",
              fontSize: "18px",
              height: "35px",
              borderRadius: "32px",
              marginTop: "15px",
              backgroundColor: `${
                currentSecondLabel === props.SecondChipLabels[2]
                  ? "#0250C1"
                  : ""
              }`,
              "&:hover": {
                backgroundColor: `${
                  props.SecondChipLabels[2] ? "#0250C1" : ""
                }`,
                color:`${
                 props.SecondChipLabels[2]
                  ? "white"
                  : ""
                }`,
              },
            }}
            onClick={() => setSecondLabel(props.SecondChipLabels[2])}
          />
        </div>}
      </div>
    </div>
  );
};

export default FilterDepositsPopup;
